<template lang="html">
  <div class="seller-wrapper">
    <div class="seller-card-wrapper">
      <!-- <h1>{{ $t('details.seller.info') }}</h1> -->
      <div class="seller-card">
        <!-- <div class="card-main-wrapper">
          <div class="image-wrapper">
            <img
              v-if="sellerInfo.usr_image"
              :src="getSrc()"
              alt="default image"
            />
            <img
              v-else
              src="@/assets/images/defaultProfileImage.png"
              alt="default image"
            />
          </div>
          <div class="main-info-wrapper">
            <span class="name">{{ sellerInfo.usr_username }}</span>
            <span class="email">{{ sellerInfo.usr_email }}</span>
          </div>
        </div> -->
        <div class="info">
          <span class="info-key">{{ $t("main.email") }}:</span>
          <span class="info-value info-email">{{ sellerInfo.usr_email }}</span>
        </div>
        <div v-for="(key, index) in dataToShow" :key="index">
          <div v-if="sellerInfo[key] && key === 'usr_rating'" class="info">
            <span class="info-key">{{ $t("details.seller." + key) }}:</span>
            <span
              class="info-value"
              style="display: flex; align-items: center;"
            >
              <span style="margin-right: 5px">{{ sellerInfo[key] }}</span>
              <rating :rating="parseFloat(sellerInfo[key])"
            /></span>
          </div>
          <div
            v-else-if="
              (sellerInfo[key] && key === 'usr_tax_info') ||
                (sellerInfo[key] && key === 'usr_business_register')
            "
            class="info"
          >
            <span class="info-key">{{ $t("details.seller." + key) }}:</span>
            <a target="_blank" :href="BaseURL + sellerInfo[key]">{{
              $t("main.fileWord")
            }}</a>
          </div>
          <template
            v-else-if="
              sellerInfo[key] && key === 'socials' && sellerInfo[key].length > 0
            "
          >
            <div v-for="soc in sellerInfo[key]" :key="soc.name" class="info">
              <span class="info-key">{{ soc.sct_name }}:</span>
              <a v-if="checkLink(soc.link)" target="_blank" :href="soc.link">
                <span class="info-value">{{ soc.link }}</span>
              </a>
              <span v-else class="info-value">{{ soc.link }}</span>
            </div>
          </template>
          <div v-else-if="sellerInfo[key] && key !== 'socials'" class="info">
            <span class="info-key">{{ $t("details.seller." + key) }}:</span>
            <span class="info-value">{{ sellerInfo[key] }}</span>
          </div>
        </div>
        <div
          v-if="userIsLoged && productInfo.my_product !== 1"
          class="msg-wrapper"
        >
          <h1>{{ $t("details.seller.messageForSeller") }}:</h1>
          <div class="wrapp-textarea">
            <textarea
              @keyup.enter="sendMsg()"
              v-model="msg"
              rows="5"
            ></textarea>
            <div v-if="msg !== ''" @click="sendMsg()" class="dropdown-btn">
              <img src="@/assets/icons/btn-arrow.png" alt="enter-btn-arrow" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="seller-rating-parent-wrapper">
      <h1>{{ $t("details.seller.comment") }}</h1>
      <div v-if="sellerRatings.length > 0" class="seller-rating-parent">
        <seller-rating
          :rating="rating"
          v-for="(rating, index) in sellerRatings"
          :key="index"
        />
      </div>
      <div v-else class="no-comment">
        {{ $t("details.seller.noComment") }}
      </div>
    </div>
  </div>
</template>

<script>
import Rating from "@/components/rating.vue";
import { api, baseURL } from "@/api";
import SellerRating from "@/components/details/sellerRating.vue";
import { mapState } from "vuex";
export default {
  name: "itemSeller",
  props: {
    productInfo: {
      required: false
    }
  },
  components: {
    SellerRating,
    Rating
  },
  data() {
    return {
      BaseURL: baseURL,
      sellerInfo: {},
      dataToShow: [
        "usr_name",
        "usr_org_full_name",
        "usr_rating",
        "socials",
        "cnt_name",
        "usr_region",
        "usr_address",
        "usr_postal_code",
        "usr_phone_number",
        "usr_phone_number1",
        "usr_phone_number2",
        "usr_phone_number3",
        "usr_org_contact_person",
        "usr_org_contact",
        "osr_name",
        "otp_name",
        "usr_org_pib",
        "usr_org_id",
        "usr_org_registration_number",
        "usr_org_bank",
        "usr_org_services",
        "usr_business_register",
        "usr_tax_info"
      ],
      sellerRatings: [],
      msg: ""
    };
  },
  mounted() {
    this.getSellerInfo();
    this.getSellerRatings();
  },
  methods: {
    checkLink(linkForCheck) {
      try {
        let link = new URL(linkForCheck);
        return link;
      } catch {
        return false;
      }
    },
    sendMsg() {
      if (this.msg !== "") {
        let params = {
          msg_message: this.msg,
          usr_id_to: this.sellerInfo.usr_id
        };
        this.connection.send(JSON.stringify(params));
        this.$toast.success(this.$t("main.msgSuccess"), {
          duration: 8000
        });
        this.msg = "";
      } else {
        this.$toast.error(this.$t("main.msgError"), {
          duration: 8000
        });
      }
    },
    getSellerInfo() {
      let params = {
        id: this.productInfo.usr_id
      };
      api
        .getSellerInfo(params)
        .then(res => {
          this.sellerInfo = res.data.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getSellerRatings() {
      let params = {
        id: this.productInfo.usr_id
      };
      api
        .getSellerRatings(params)
        .then(res => {
          this.sellerRatings = res.data.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getSrc() {
      return baseURL + this.sellerInfo.usr_image;
    }
  },
  computed: {
    ...mapState(["userIsLoged", "connection"])
  }
};
</script>

<style lang="scss" scoped>
.seller-wrapper {
  // display: flex;
  // flex-direction: row;
  // align-items: flex-start;
  // justify-content: space-between;
  margin: 0 auto;

  margin-top: 20px;
  margin-bottom: 30px;
  text-align: left;

  .no-comment {
    text-align: left;
  }

  h1 {
    // margin: 0;
    margin: 25px 0 10px 0;
    text-align: left;

    font-weight: 400;
    font-style: Regular;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0%;
    color: $gray-blue-1300;
  }

  // @import "@/assets/scss/cardStyles.scss";
  .seller-rating-parent-wrapper {
    width: 100%;
    .seller-rating-parent {
      display: flex;
      flex-direction: column-reverse;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }
  .msg-wrapper {
    h1 {
      color: $blue-400;
    }
  }
  .wrapp-textarea {
    display: flex;
    align-items: end;
  }
  textarea {
    box-sizing: border-box;
    width: 620px;
    max-width: calc(100% - 50px);
    border: 1px solid $blue-200;
    outline: none;
    resize: none;
    margin-top: 5px;
  }
  .dropdown-btn {
    cursor: pointer;
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #efa099;
    border-radius: 3px;
    margin-left: 5px;
  }
  .seller-card-wrapper {
    .main-info-wrapper {
      max-width: 100%;
      overflow: hidden;

      * {
        max-width: 100%;
        text-overflow: ellipsis;
        // word-break: break-all;
        overflow: hidden;
      }
    }
  }
}
.info {
  box-sizing: border-box;
  width: 100%;
  // margin-bottom: 15px;
  display: flex;
  flex-direction: row;
  // align-items: center;
  // flex-wrap: wrap;
  min-height: 43px;
  padding: 15px;
  border-bottom: 1px solid $gray-blue-700;

  font-weight: 400;
  font-style: Regular;
  font-size: 18px;
  line-height: 130%;
  letter-spacing: 0%;

  .info-key {
    width: 248px;
    min-width: 248px;

    color: $blue-400;
    margin-right: 15px;
    white-space: break-spaces;

    // width: 300px;
  }
  .info-value {
    margin-left: 15px;

    color: $blue-1000;
    // word-break: break-all;
    img {
      width: 23px;
    }
  }
}
@media only screen and (max-width: 768px) {
  .seller-wrapper {
    flex-direction: column;

    .seller-card-wrapper {
      width: 100%;
      margin-bottom: 30px;

      .seller-card {
        padding: 0px;
      }
    }
    .seller-rating-parent-wrapper {
      width: 100%;
    }
  }
  .info {
    box-sizing: border-box;
    width: 100%;
    // margin-bottom: 15px;
    display: flex;
    flex-direction: column;

    min-height: 43px;
    padding: 5px;

    font-size: 16px;
    line-height: 130%;

    .info-value {
      margin-bottom: 20px;
      // white-space: break-spaces !important;
      // word-break: break-all !important;
      img {
        width: 18px;
      }
    }
    .info-email {
      word-break: break-all !important;
    }
  }

  .info-key {
    white-space: normal !important;
    // width: 100% !important;
    // min-width: 100% !important;
  }
}
</style>
